import React, { memo } from 'react';

function formatTime(val) {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

function formatDowMonthDay(val) {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
}

const StandaloneAssignmentCard = memo(function StandaloneAssignmentCard({
  assignment,
  courseName = 'Course'
}) {
  const assignmentTitle = assignment?.title || assignment?.name || 'Assignment';
  const dueDate = assignment?.dueDatetime || assignment?.dueDate || assignment?.dueAt || assignment?.due_at || assignment?.due;
  const description = assignment?.description || '';

  const handleClick = () => {
    try {
      window.dispatchEvent(new CustomEvent('scoutiq:openAssignmentModal', { 
        detail: { assignment } 
      }));
    } catch (e) {
      console.warn('StandaloneAssignmentCard: Failed to open assignment modal', e);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div 
      className="standaloneAssignmentCard"
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={`${assignmentTitle} - ${courseName}`}
    >
      {/* Date-time at top */}
      <div className="standaloneAssignmentDateTime">
        <div className="standaloneAssignmentDate">{formatDowMonthDay(dueDate)}</div>
        <div className="standaloneAssignmentTime">{formatTime(dueDate)}</div>
      </div>

      <div className="standaloneAssignmentDivider" />

      {/* Course name */}
      <div className="standaloneAssignmentCourse">{courseName}</div>

      {/* Assignment title */}
      <div className="standaloneAssignmentTitle">{assignmentTitle}</div>

      {/* Description */}
      {description && (
        <div className="standaloneAssignmentDescription">{description}</div>
      )}
    </div>
  );
});

export default StandaloneAssignmentCard;
